module.exports = __webpack_public_path__ + "static/img/champ-banner-chatting.48646ff.png";